import { Box, Grid, Typography, useTheme } from '@mui/material';
import Question from './Question';
import { useFormContext } from 'react-hook-form';
import { useEffect, useState } from 'react';

const Questionnaire = (props) => {
    const { data, flatQuestions, append, fields, editMode = true, name = null, functionId = null, pfid = null } = props;
    const [idx, setIdx] = useState(fields.findIndex((field) => field.questionnaireId === data?.QuestionnaireId));
    const theme = useTheme();
    const form = useFormContext();

    useEffect(() => {
        if (functionId || pfid)
            append({
                questionnaireId: data?.QuestionnaireId,
                questionnaireTitle: data?.QuestionnaireTitle,
                answers: '',
                functionId,
                personFunctionId: pfid
            });
        else
            append({
                questionnaireId: data?.QuestionnaireId,
                questionnaireTitle: data?.QuestionnaireTitle,
                answers: ''
            });
    }, []);

    useEffect(() => {
        setIdx(fields.findIndex((field) => field.questionnaireId === data?.QuestionnaireId));
    }, [fields]);

    return (
        <Box sx={{ flexGrow: 1, background: theme.palette.background.default, borderRadius: 3, boxShadow: 1, p: 2 }}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        {data?.QuestionnaireTidtle ?? ''}
                    </Typography>
                </Grid>
                {flatQuestions &&
                    data?.Questions &&
                    data?.Questions.map((question, index) => {
                        return (
                            <Grid item xs={12} key={question?.Id}>
                                <Question
                                    question={question}
                                    questionnaireId={data?.QuestionnaireId}
                                    fields={fields}
                                    questionnaireIndex={idx}
                                    questionIndex={index}
                                    editMode={editMode}
                                    name={name}
                                />
                            </Grid>
                        );
                    })}
            </Grid>
        </Box>
    );
};

export default Questionnaire;
